import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAgreement } from "../hooks/use-agreement";
import { useAuth } from "../hooks/use-auth";
import type { AuthType } from "../redux/types";
import { AgreementModalPresentation } from "./Components/AgreementModalPresentation";
import { AuthErrorMessage } from "./Components/AuthErrorMessage";
import { LoginInput } from "./Components/LoginInput";
import { PasswordInput } from "./Components/PasswordInput";
import { SubmitButton } from "./Components/SubmitButton";
import { UserAgreementCheckbox } from "./Components/UserAgreementCheckbox";
import styles from "./styles.module.css";

interface Props {
  btnText: string;
  formLocation: AuthType;
}

export const AuthForm = ({ btnText, formLocation }: Props) => {
  const {
    username,
    password,
    validationData,
    onSubmit,
    handleChangePassword,
    handleChangeUserName,
  } = useAuth();
  const {
    agree,
    isOpenAgreementModal,
    handleCheckAgreement,
    handleOpenAgreementModal,
    handleCloseIsOpenAgreementModal,
    handleChangeAgreement,
  } = useAgreement();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const { t } = useTranslation();

  const handlePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  const handleSubmit = () => {
    onSubmit(formLocation);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t("login.title")}</h1>
      <div className={styles["form-wrapper"]}>
        <LoginInput username={username} onChange={handleChangeUserName} />
        <PasswordInput
          password={password}
          onChange={handleChangePassword}
          isPasswordVisible={isPasswordVisible}
          onClick={handlePasswordVisibility}
        />
      </div>
      {
        <UserAgreementCheckbox
          isChecked={agree}
          onAgreementChange={handleChangeAgreement}
          handleOpenAgreement={handleOpenAgreementModal}
        />
      }
      <SubmitButton
        onSubmit={handleSubmit}
        btnText={btnText}
        disabled={!agree ? true : false}
      />
      <AuthErrorMessage validationData={validationData} />
      <AgreementModalPresentation
        open={isOpenAgreementModal}
        handleOk={handleCheckAgreement}
        onClose={handleCloseIsOpenAgreementModal}
      />
    </div>
  );
};
